import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/users/$userId/_layout/_identity/')({});